module.exports = __webpack_public_path__ + "static/media/project_demo_2.b784d3e6.png";